/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Consequences_IntroInputs */

const en_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you delete your Brave Premium account, the following will happen:`)
};

const id_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda menghapus akun Brave Premium Anda, berikut ini akan terjadi:`)
};

const ms_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika anda memadamkan akaun Brave Premium anda, perkara berikut akan berlaku:`)
};

const ca_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si elimines el teu compte Brave Premium, succeirà el següent:`)
};

const cs_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud odstraníte svůj účet Brave Premium, dojde k následujícímu:`)
};

const da_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du sletter din Brave Premium-konto, vil følgende ske:`)
};

const de_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie Ihr Brave Premium-Konto löschen, passiert Folgendes:`)
};

const et_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui kustutate oma Brave Premium'i konto, juhtub järgmist:`)
};

const es_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si eliminas tu cuenta de Brave Premium, sucederá lo siguiente:`)
};

const fr_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici ce qui se passera si vous supprimez votre compte Brave Premium :`)
};

const hr_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ako izbrišete svoj Brave Premium račun, dogodit će se sljedeće:`)
};

const it_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se elimini il tuo account Brave Premium, avranno effetto i seguenti cambiamenti::`)
};

const lv_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja dzēsīsiet savu Brave Premium kontu, notiks sekojošais:`)
};

const lt_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ištrynę savo Brave Premium paskyrą, įvyks šie dalykai:`)
};

const hu_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha törli a Brave prémium fiókját, a következő fog történni:`)
};

const nl_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je je Brave Premium-account verwijdert, gebeurt het volgende:`)
};

const nb_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du sletter Brave Premium-kontoen din, skjer følgende:`)
};

const pl_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli usuniesz swoje konto Brave Premium:`)
};

const pt_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você excluir sua conta Brave Premium, o seguinte acontecerá:`)
};

const ro_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dacă ștergeți contul dvs. Brave Premium, urmează să se întâmple următoarele:`)
};

const sk_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ak svoj účet Brave Premium vymažete, stane sa nasledovné:`)
};

const sl_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Če izbrišete svoj račun Brave Premium, se bo zgodilo naslednje:`)
};

const fi_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos poistat Brave Premium -tilisi, seuraavaa tapahtuu:`)
};

const sv_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du raderar ditt Brave Premium-konto, kommer följande att hända:`)
};

const vi_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu bạn xóa tài khoản Brave Premium của mình, các điều sau đây sẽ xảy ra:`)
};

const tr_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Premium hesabınızı silerseniz şunlar olacaktır:`)
};

const el_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εάν διαγράψετε τον λογαριασμό σας στο Brave Premium, θα συμβούν τα εξής:`)
};

const bg_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако изтриете своя Brave Premium акаунт, ще се случи следното:`)
};

const ru_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если вы удалите свой аккаунт Brave Premium, будут выполнены следующие действия:`)
};

const sr_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ако избришете свој Brave премиум налог, следеће ће се десити:`)
};

const uk_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Якщо ви видалите свій обліковий запис Brave Premium, відбудеться наступне:`)
};

const ka_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თუ თქვენ წაშლით თქვენს Brave Premium ანგარიშს, შემდეგი მოხდება:`)
};

const hi_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि आप अपना Brave प्रीमियम खाता हटाते हैं, तो निम्नलिखित होगा:`)
};

const th_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากคุณลบบัญชี Brave Premium ของคุณ จะเกิดสิ่งต่อไปนี้:`)
};

const ko_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 프리미엄 계정 삭제 후 절차:`)
};

const zh_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您删除 Brave Premium 账户，将会发生以下情况：`)
};

const zh_tw_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`若您刪除 Brave 高級版帳戶，將會發生以下情況：`)
};

const ja_delete_account_consequences_intro = /** @type {(inputs: Delete_Account_Consequences_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveプレミアムアカウントを削除した場合、以下のことが起こります。`)
};

/**
* | output |
* | --- |
* | "If you delete your Brave Premium account, the following will happen:" |
*
* @param {Delete_Account_Consequences_IntroInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_account_consequences_intro = /** @type {((inputs?: Delete_Account_Consequences_IntroInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Consequences_IntroInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_account_consequences_intro(inputs)
	if (locale === "ms") return ms_delete_account_consequences_intro(inputs)
	if (locale === "ca") return ca_delete_account_consequences_intro(inputs)
	if (locale === "cs") return cs_delete_account_consequences_intro(inputs)
	if (locale === "da") return da_delete_account_consequences_intro(inputs)
	if (locale === "de") return de_delete_account_consequences_intro(inputs)
	if (locale === "et") return et_delete_account_consequences_intro(inputs)
	if (locale === "es") return es_delete_account_consequences_intro(inputs)
	if (locale === "fr") return fr_delete_account_consequences_intro(inputs)
	if (locale === "hr") return hr_delete_account_consequences_intro(inputs)
	if (locale === "it") return it_delete_account_consequences_intro(inputs)
	if (locale === "lv") return lv_delete_account_consequences_intro(inputs)
	if (locale === "lt") return lt_delete_account_consequences_intro(inputs)
	if (locale === "hu") return hu_delete_account_consequences_intro(inputs)
	if (locale === "nl") return nl_delete_account_consequences_intro(inputs)
	if (locale === "nb") return nb_delete_account_consequences_intro(inputs)
	if (locale === "pl") return pl_delete_account_consequences_intro(inputs)
	if (locale === "pt") return pt_delete_account_consequences_intro(inputs)
	if (locale === "ro") return ro_delete_account_consequences_intro(inputs)
	if (locale === "sk") return sk_delete_account_consequences_intro(inputs)
	if (locale === "sl") return sl_delete_account_consequences_intro(inputs)
	if (locale === "fi") return fi_delete_account_consequences_intro(inputs)
	if (locale === "sv") return sv_delete_account_consequences_intro(inputs)
	if (locale === "vi") return vi_delete_account_consequences_intro(inputs)
	if (locale === "tr") return tr_delete_account_consequences_intro(inputs)
	if (locale === "el") return el_delete_account_consequences_intro(inputs)
	if (locale === "bg") return bg_delete_account_consequences_intro(inputs)
	if (locale === "ru") return ru_delete_account_consequences_intro(inputs)
	if (locale === "sr") return sr_delete_account_consequences_intro(inputs)
	if (locale === "uk") return uk_delete_account_consequences_intro(inputs)
	if (locale === "ka") return ka_delete_account_consequences_intro(inputs)
	if (locale === "hi") return hi_delete_account_consequences_intro(inputs)
	if (locale === "th") return th_delete_account_consequences_intro(inputs)
	if (locale === "ko") return ko_delete_account_consequences_intro(inputs)
	if (locale === "zh") return zh_delete_account_consequences_intro(inputs)
	if (locale === "zh-tw") return zh_tw_delete_account_consequences_intro(inputs)
	if (locale === "ja") return ja_delete_account_consequences_intro(inputs)
	return en_delete_account_consequences_intro(inputs)
});